<template>
	<div class="white-box">
		<h3 class="box-title">PRESUPUESTOS POR ESTADOS</h3>
		<line-chart :options="options" :chart-data="datacollection"></line-chart>
	</div>
</template>
<script>
	import LineChart from './../../../../charts/basics/ChartLine.vue';
	export default {
		props: ['user', 'isAuth'],
		components: {
			LineChart,
		},
		data () {
			return {
				data: null,
				labels: [],
				series: [],
				datacollection: null,
				chart: null,
				options: {
					responsive: true,
					elements: {
						line: {
							fill: false
						}
					},
					scales: {
						yAxes: [{
							ticks: {
								beginAtZero: true,
								callback: function (value) { if (Number.isInteger(value)) { return value; } },
								stepSize: 10
							}
						}]
					},
				},
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/management/charts/new/budgets/per/day')
				.then(response => {
					this.data = response.body
					this.loadData()
				})
			},
			loadData() {
				var that = this
				var labels = []
				var series = []

				this.data.labels.forEach(function(value) {
					var date = moment(value).format('dddd')
					var day = that.$options.filters.ucfirst(date)
					labels.push(day)
				})

				this.labels = labels
				this.series = this.data.data
				this.datacollection = {
					labels: this.labels,
					datasets: this.series,
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/dashboard/views/charts/newBudgetsPerDay.vue